import axios from 'axios'
import { Message } from 'element-ui'
import { Notify } from 'vant'
import { default as webRouter } from '@/modules/workOnline/router'
import { default as mobileRouter } from '@/modules/officialAccounts/router'

const isMobile = /Mobile|Android|iPhone/i.test(navigator.userAgent)

axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'

const service = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? '/symy' : projectConfig.baseURL,
  timeout: 8000
})

// service.interceptors.request.use(
//   config => {
//     return config
//   },
//   error => {
//     return Promise.reject(error)
//   }
// )
service.interceptors.request.use(
  config => {
    // 从 localStorage 获取 token
    const token = localStorage.getItem('sys_token')

    // 如果 token 存在，将其添加到请求头
    if (token) {
      config.headers['Token'] = `${token}`
    }

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(response => {
  const { data } = response
  if (data.code && data.code !== 2000 && data.code !== 200) {
    switch (data.code) {
      case 4010:
        if (isMobile) {
          window.location.href = projectConfig.jumpURL + '/mobile/'
          // mobileRouter.push('/login') // 移动端首页本地调试
        } else {
          let loginType = localStorage.getItem('loginType')
          let casLoginUrl = localStorage.getItem('casLoginUrl')
          if (loginType == 1) {
            window.location.href = `${projectConfig.jumpURL}/#/login`
          } else if (loginType == 2) {
            window.location.href = `${casLoginUrl}`
          }
          // window.location.href = `http://192.168.1.103:7070/cas/login`
        }
        break
      case 4001: // 未登录，不做任何操作
        break
      default:
        if (isMobile) {
          return Promise.reject(Notify({
            message: data.message || data.msg,
            type: 'warning',
          }))
        } else {
          return Promise.reject(Message({
            message: data.message || data.msg,
            type: 'warning',
          }))
        }
    }
  } else {
    return data
  }
}, error => {
  if (isMobile) {
    return Promise.reject(Notify({
      message: '请求失败，请刷新页面或联系管理员',
      type: 'warning',
    }))
  } else {
    return Promise.reject(Message({
      message: '请求失败，请刷新页面或联系管理员',
      type: 'warning',
    }))
  }
})

export default service